import { render, staticRenderFns } from "./Valoracion.vue?vue&type=template&id=e847b15a"
import script from "./Valoracion.vue?vue&type=script&lang=js"
export * from "./Valoracion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports